import { IconProps } from '../types';
import classnames from 'classnames';

interface Props extends IconProps {
  type?: 1 | 2;
}

export default function AmericanExpressIcon(props: Props) {
  const { className, style, type = 1 } = props;

  if (type === 2) {
    return (
      <svg className={classnames('h-4', className)} viewBox="0 0 154 39" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.3285 0L0 38.3473H20.7446L23.3163 32.2332H29.1947L31.7665 38.3473H54.6005V33.6808L56.6351 38.3473H68.4466L70.4813 33.5822V38.3473H117.97L123.744 32.392L129.151 38.3473L153.542 38.3967L136.159 19.2807L153.542 0H129.529L123.908 5.84532L118.672 0H67.0104L62.5743 9.89778L58.034 0H37.3327V4.50774L35.0298 0H17.3285ZM88.2428 5.44539H115.513L123.854 14.4549L132.463 5.44539H140.804L128.131 19.2753L140.804 32.9459H132.085L123.744 23.8318L115.091 32.9459H88.2428V5.44539ZM94.9771 16.1659V11.1427V11.1379H111.993L119.417 19.1712L111.664 27.2485H94.9771V21.7646H109.854V16.1659H94.9771ZM21.3424 5.44539H31.4543L42.9483 31.4489V5.44539H54.0255L62.9033 24.0898L71.0851 5.44539H82.107V32.9621H75.4004L75.3457 11.4002L65.5682 32.9621H59.5689L49.7367 11.4002V32.9621H35.9398L33.3242 26.7932H19.1929L16.5827 32.9567H9.1905L21.3424 5.44539ZM21.6058 21.0904L26.2615 10.1011L30.9118 21.0904H21.6058Z"
          fill="white"
        />
      </svg>
    );
  }

  return (
    <svg className={classnames('h-4', className)} viewBox="0 0 38 25" fill="none" style={style}>
      <g clipPath="url(#clip0_21073_131665)">
        <path
          d="M35 0.5H3C1.3 0.5 0 1.8 0 3.5V21.5C0 23.2 1.4 24.5 3 24.5H35C36.7 24.5 38 23.2 38 21.5V3.5C38 1.8 36.6 0.5 35 0.5Z"
          fill="#DEDEDE"
        />
        <path
          d="M35 1.5C36.1 1.5 37 2.4 37 3.5V21.5C37 22.6 36.1 23.5 35 23.5H3C1.9 23.5 1 22.6 1 21.5V3.5C1 2.4 1.9 1.5 3 1.5H35Z"
          fill="#006FCF"
        />
        <path
          d="M8.971 10.768L9.745 12.644H8.203L8.971 10.768ZM25.046 10.846H22.069V11.673H24.998V12.912H22.075V13.834H25.052V14.573L27.129 12.328L25.052 9.988L25.046 10.846ZM10.983 8.506H14.978L15.865 10.441L16.687 8.5H27.057L28.135 9.69L29.25 8.5H34.013L30.494 12.352L33.977 16.18H29.143L28.065 14.99L26.94 16.18H10.03L9.536 14.99H8.406L7.911 16.18H4L7.286 8.5H10.716L10.983 8.506ZM19.646 9.584H17.407L15.907 13.12L14.282 9.584H12.06V14.394L10 9.584H8.007L5.625 15.096H7.18L7.674 13.906H10.27L10.764 15.096H13.484V11.161L15.235 15.102H16.425L18.165 11.173V15.103H19.623L19.647 9.583L19.646 9.584ZM28.986 12.352L31.517 9.584H29.695L28.094 11.31L26.546 9.584H20.652V15.102H26.462L28.076 13.364L29.624 15.102H31.499L28.987 12.352H28.986Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_21073_131665">
          <rect width="38" height="24" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
